$(() => {
    // jquery_ui datepicker max yıl için
    var tenYearsAgo = new Date();
    tenYearsAgo.setFullYear(tenYearsAgo.getFullYear() - 10);

    // jquery-validate select boş kontrolü için
    $.validator.addMethod(
        "notEqual",
        function (value, element, param) {
            return value !== param;
        },
        ""
    );

    // Sadece harf girilebilir
    jQuery.validator.addMethod(
        "lettersonly",
        function (value, element) {
            return (
                this.optional(element) ||
                /^[a-z áãâäàéêëèíîïìóõôöòúûüùĞğçñİıŞş]+$/i.test(value)
            );
        },
        "Sadece Harf Giriniz."
    );

    $.ajaxSetup({
        headers: {
            "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
        },
    });

    $(document).on("change", ".ulkelerSelect", function () {
        var data = $(this).val();
        var url = $(this).attr("data-url");
        if (data.trim() != "") {
            var veri = { UlkeId: data };
            $.ajax({
                type: "POST",
                method: "POST",
                data: veri,
                url: url,
                dataType: "json",
                beforeSend: function () {
                    $("#sehirlerSelect").prop("disabled", "disabled");
                    $("#sehirlerSelect").html("");
                },
                success: function (cevap) {
                    select = document.getElementById("sehirlerSelect");
                    select.innerText = null;

                    var opt = document.createElement("option");
                    opt.value = "";
                    opt.innerHTML = lang_seciniz;
                    select.appendChild(opt);

                    cevap.forEach(function (e) {
                        var opt = document.createElement("option");
                        opt.value = e.Id;
                        opt.innerHTML = e.SehirAdi;
                        select.appendChild(opt);
                    });

                    select.disabled = false;
                },
                error: function (hata) {},
            });
        } else {
            $("#sehirlerSelect").prop("disabled", "disabled");
            $("#sehirlerSelect").html("");
            var opt = document.createElement("option");
            opt.value = "";
            opt.innerHTML = "Seçiniz";
            $("#sehirlerSelect").appendChild(opt);
        }
    });

    // Kayıt ol sayfası için -> Sayfa yüklendiğinde ve radio butonları değiştiğinde tckimlik radio butonu için doğrulama kurallarını kontrol et
    $("input[name='TCVatandasi']").on("change", function () {
        checkTcKimlikNoValidation();
    });

    // Kayıt sorgula sayfası için -> Sayfa yüklendiğinde ve radio butonları değiştiğinde sorgu türü radio butonu için doğrulama kurallarını kontrol et
    $("input[name='sorguGrup']").on("change", function () {
        $('input[name="sorguGrup"]').css("border-color", "");
        $('input[name="TcKimlikNo"],input[name="PassaportNo"]').removeClass(
            "is-invalid"
        );
        $('input[name="TcKimlikNo"],input[name="PassaportNo"]')
            .next("em")
            .remove();
        $('input[name="TcKimlikNo"],input[name="PassaportNo"]').val("");
        $('input[name="TcKimlikNo"],input[name="PassaportNo"]').attr(
            "value",
            ""
        );
        checkKayitSorguVeriTurValidation();
    });

    if ($("#dogumTarihi")) {
        // Doğum tarihi için jquery ui datepicker
        $("#dogumTarihi").datepicker({
            dateFormat: "dd-mm-yy",
            altFormat: "dd-mm-yy",
            changeMonth: true,
            changeYear: true,
            yearRange: "1930:" + $.datepicker.formatDate("yy", tenYearsAgo),
        });
        $("#datepicker").datepicker($.datepicker.regional["tr-TR"]);
    }

    const formValidator = $("#kayitOlForm").validate({
        rules: {
            YarisBilgiId: { required: true, notEqual: "" },
            Ad: { required: true, minlength: 2, maxlength: 128 },
            Soyad: { required: true, minlength: 2, maxlength: 128 },
            TcKimlikNo: {
                required: true,
                digits: true,
                minlength: 11,
                maxlength: 11,
            },
            DogumTarihi: "required",
            UlkeId: { required: true, notEqual: "" },
            SehirId: { required: true, notEqual: "" },
            TelefonNo: { required: true },
            PassaportNo: { required: true, maxlength: 9 },
            EPosta: {
                required: true,
                email: true,
                minlength: 6,
                maxlength: 128,
            },
            Adres: { required: true, minlength: 6, maxlength: 512 },
            KanGrubu: { required: true, notEqual: "" },
            AcilDurumYakinAd: { required: true, minlength: 2, maxlength: 128 },
            AcilDurumYakinSoyad: {
                required: true,
                minlength: 2,
                maxlength: 128,
            },
            AcilDurumYakinTelefonNo: { required: true },
            AcilDurumYakinlik: { required: true, minlength: 2, maxlength: 32 },
            IbanAdSoyad: { required: true },
            Iban: { required: true },
            PromosyonKodu: { maxlength: 24 },
            SozlesmeCheckbox: "required",
            AcikRizaMetniOkudum: "required",
        },
        messages: {
            YarisBilgiId: {
                required: lang_seciniz,
                notEqual: lang_seciniz,
            },
            Ad: {
                required: lang_validation_mesaj_lutfen_bir_deger_giriniz,
                minlength:
                    lang_validation_mesaj_en_az_olmasi_gereken_karakter_sayisi +
                    ": 2",
                maxlength:
                    lang_validation_mesaj_en_fazla_olmasi_gereken_karakter_sayisi +
                    ": 128",
            },
            Soyad: {
                required: lang_validation_mesaj_lutfen_bir_deger_giriniz,
                minlength:
                    lang_validation_mesaj_en_az_olmasi_gereken_karakter_sayisi +
                    ": 2",
                maxlength:
                    lang_validation_mesaj_en_fazla_olmasi_gereken_karakter_sayisi +
                    ": 128",
            },
            TcKimlikNo: {
                required: lang_validation_mesaj_tc_kimlik_zorunlu,
                digits: lang_validation_mesaj_tc_kimlik_sadece_sayi_olmali,
                minlength: lang_validation_mesaj_tc_kimlik_11_karakter,
                maxlength: lang_validation_mesaj_tc_kimlik_11_karakter,
            },
            DogumTarihi: lang_validation_mesaj_dogum_tarihi_alani_zorunlu,
            UlkeId: {
                required: lang_validation_mesaj_ulke_alani_zorunlu,
                notEqual: lang_validation_mesaj_gecerli_ulke_secin,
            },
            SehirId: {
                required: lang_validation_mesaj_sehir_alani_zorunlu,
                notEqual: lang_validation_mesaj_gecerli_sehir_secin,
            },
            PassaportNo: {
                required: lang_validation_mesaj_pasaport_zorunlu,
                maxlength: lang_validation_mesaj_pasaport_7_karakter,
            },
            TelefonNo: {
                required: lang_validation_mesaj_lutfen_bir_deger_giriniz,
            },
            EPosta: {
                required: lang_validation_mesaj_lutfen_bir_deger_giriniz,
                email: lang_validation_mesaj_eposta_formatina_uygun_deger_giriniz,
                minlength:
                    lang_validation_mesaj_en_az_olmasi_gereken_karakter_sayisi +
                    ": 6",
                maxlength:
                    lang_validation_mesaj_en_fazla_olmasi_gereken_karakter_sayisi +
                    ": 128",
            },
            Adres: {
                required: lang_validation_mesaj_lutfen_bir_deger_giriniz,
                minlength:
                    lang_validation_mesaj_en_az_olmasi_gereken_karakter_sayisi +
                    ": 6",
                maxlength:
                    lang_validation_mesaj_en_fazla_olmasi_gereken_karakter_sayisi +
                    ": 512",
            },
            KanGrubu: {
                required: lang_validation_mesaj_kan_grubu_alani_zorunlu,
                notEqual: lang_validation_mesaj_gecerli_kan_grubu_secin,
            },
            AcilDurumYakinAd: {
                required: lang_validation_mesaj_lutfen_bir_deger_giriniz,
                minlength:
                    lang_validation_mesaj_en_az_olmasi_gereken_karakter_sayisi +
                    ": 2",
                maxlength:
                    lang_validation_mesaj_en_fazla_olmasi_gereken_karakter_sayisi +
                    ": 128",
            },
            AcilDurumYakinSoyad: {
                required: lang_validation_mesaj_lutfen_bir_deger_giriniz,
                minlength:
                    lang_validation_mesaj_en_az_olmasi_gereken_karakter_sayisi +
                    ": 2",
                maxlength:
                    lang_validation_mesaj_en_fazla_olmasi_gereken_karakter_sayisi +
                    ": 128",
            },
            AcilDurumYakinTelefonNo: {
                required: lang_validation_mesaj_lutfen_bir_deger_giriniz,
            },
            AcilDurumYakinlik: {
                required: lang_validation_mesaj_lutfen_bir_deger_giriniz,
                minlength:
                    lang_validation_mesaj_en_az_olmasi_gereken_karakter_sayisi +
                    ": 2",
                maxlength:
                    lang_validation_mesaj_en_fazla_olmasi_gereken_karakter_sayisi +
                    ": 32",
            },
            IbanAdSoyad: {
                required: lang_validation_mesaj_lutfen_bir_deger_giriniz,
            },
            Iban: {
                required: lang_validation_mesaj_lutfen_bir_deger_giriniz,
            },
            PromosyonKodu: {
                maxlength:
                    lang_validation_mesaj_en_fazla_olmasi_gereken_karakter_sayisi +
                    ": 24",
            },
            SozlesmeCheckbox: "",
            AcikRizaMetniOkudum: "",
        },
        errorElement: "em",
        errorPlacement: function (i, e) {
            i.addClass("invalid-feedback"),
                "checkbox" === e.prop("type")
                    ? i.insertAfter(e.next("label"))
                    : i.insertAfter(e);
        },
        highlight: function (i, e, a) {
            $(i).addClass("is-invalid").removeClass("is-valid");
        },
        unhighlight: function (i, e, a) {
            $(i).addClass("is-valid").removeClass("is-invalid");
        },
        submitHandler: function (form) {
            var buyukAd = $("#Ad").val().toLocaleUpperCase("TR");
            var buyukSoyad = $("#Soyad").val().toLocaleUpperCase("TR");

            $("#Ad").val(buyukAd);
            $("#Soyad").val(buyukSoyad);
            $("#Ad").attr("value", buyukAd);
            $("#Soyad").attr("value", buyukSoyad);

            unmaskPhone = $("#TelefonNo").val().replace(/\D/g, "");
            $("#TelefonNo").val(unmaskPhone);

            unmaskPhone2 = $("#AcilDurumYakinTelefonNo")
                .val()
                .replace(/\D/g, "");
            $("#AcilDurumYakinTelefonNo").val(unmaskPhone2);

            kayitFormunuYolla(form);
        },
    });

    function checkTcKimlikNoValidation() {
        if ($("input[name='TCVatandasi']").val() !== undefined) {
            var isTcVatandasi =
                $("input[name='TCVatandasi']:checked").val() === "1";
            if (isTcVatandasi) {
                formValidator.settings.rules.TcKimlikNo.required = true;
                formValidator.settings.rules.TelefonNo.required = true;
                formValidator.settings.rules.PassaportNo.required = false;
            } else {
                formValidator.settings.rules.TcKimlikNo.required = false;
                formValidator.settings.rules.TelefonNo.required = false;
                formValidator.settings.rules.PassaportNo.required = true;
            }
        }
    }
    checkTcKimlikNoValidation();

    const formValidator_kayitSorgula = $("#kayitSorgulaForm").validate({
        rules: {
            TcKimlikNo: { digits: true, minlength: 11, maxlength: 11 },
            DogumTarihi: { required: true },
            PassaportNo: { maxlength: 9 },
            Captcha: { required: true },
        },
        messages: {
            TcKimlikNo: {
                required: lang_validation_mesaj_tc_kimlik_zorunlu,
                digits: lang_validation_mesaj_tc_kimlik_sadece_sayi_olmali,
                minlength: lang_validation_mesaj_tc_kimlik_11_karakter,
                maxlength: lang_validation_mesaj_tc_kimlik_11_karakter,
            },
            DogumTarihi: lang_validation_mesaj_dogum_tarihi_alani_zorunlu,
            PassaportNo: {
                required: lang_validation_mesaj_pasaport_zorunlu,
                maxlength: lang_validation_mesaj_pasaport_7_karakter,
            },
            Captcha: lang_validation_mesaj_lutfen_bir_deger_giriniz,
        },
        errorElement: "em",
        errorPlacement: function (i, e) {
            i.addClass("invalid-feedback"),
                "checkbox" === e.prop("type")
                    ? i.insertAfter(e.next("label"))
                    : i.insertAfter(e);
        },
        highlight: function (i, e, a) {
            $(i).addClass("is-invalid").removeClass("is-valid");
        },
        unhighlight: function (i, e, a) {
            $(i).addClass("is-valid").removeClass("is-invalid");
        },
        submitHandler: function (form) {
            kayitSorgulaFormunuYolla(form);
        },
    });

    function checkKayitSorguVeriTurValidation() {
        if ($("input[name='sorguGrup']").val() !== undefined) {
            var tcIleSorgu = $("input[name='sorguGrup']:checked").val() === "1";
            if (tcIleSorgu) {
                formValidator_kayitSorgula.settings.rules.TcKimlikNo.required = true;
                formValidator_kayitSorgula.settings.rules.TcKimlikNo.digits = true;
                formValidator_kayitSorgula.settings.rules.PassaportNo.required = false;
            } else {
                formValidator_kayitSorgula.settings.rules.PassaportNo.required = true;
                formValidator_kayitSorgula.settings.rules.TcKimlikNo.required = false;
            }
        }
    }

    checkKayitSorguVeriTurValidation();

    const formValidator_smsForm = $("#kayitOlSmsForm").validate({
        rules: {
            smsCode: { required: !0, digits: !0, minlength: 6, maxlength: 6 },
        },
        messages: {
            smsCode: {
                required: lang_validation_mesaj_lutfen_bir_deger_giriniz,
                digits: lang_validation_mesaj_sadece_rakam_giriniz,
                minlength:
                    lang_validation_mesaj_en_az_olmasi_gereken_karakter_sayisi +
                    ": 6",
                maxlength:
                    lang_validation_mesaj_en_fazla_olmasi_gereken_karakter_sayisi +
                    ": 6",
            },
        },
        errorElement: "em",
        errorPlacement: function (i, e) {
            i.addClass("invalid-feedback"),
                "checkbox" === e.prop("type")
                    ? i.insertAfter(e.next("label"))
                    : i.insertAfter(e);
        },
        highlight: function (i, e, a) {
            $(i).addClass("is-invalid").removeClass("is-valid");
        },
        unhighlight: function (i, e, a) {
            $(i).addClass("is-valid").removeClass("is-invalid");
        },
        submitHandler: function (form) {
            smsFormunuYolla(form);
        },
    });

    $("#cardForm").validate({
        rules: {
            number: {
                required: !0,
                creditcard: true,
                minlength: 19,
                maxlength: 19,
            },
            name: { required: !0, lettersonly: true, minlength: 5 },
            expiry: { required: !0 },
            // expiry: { required: !0, minlength: 9, },
            cvc: { required: !0, minlength: 3 },
        },
        messages: {
            number: {
                required: lang_validation_mesaj_lutfen_bir_deger_giriniz,
                creditcard: lang_validation_mesaj_gecersiz_kart_numarasi,
                maxlength:
                    lang_validation_mesaj_en_fazla_olmasi_gereken_karakter_sayisi +
                    ": 16",
                minlength:
                    lang_validation_mesaj_en_az_olmasi_gereken_karakter_sayisi +
                    ": 16",
            },
            name: {
                required: lang_validation_mesaj_lutfen_bir_deger_giriniz,
                lettersonly: lang_validation_mesaj_sadece_harf_giriniz,
                minlength:
                    lang_validation_mesaj_en_az_olmasi_gereken_karakter_sayisi +
                    ": 5",
            },
            expiry: {
                required: lang_validation_mesaj_lutfen_bir_deger_giriniz,
                // minlength: "Geçerlilik tarihini aa/yyyy formatında giriniz"
            },
            cvc: {
                required: lang_validation_mesaj_lutfen_bir_deger_giriniz,
                minlength:
                    lang_validation_mesaj_en_az_olmasi_gereken_karakter_sayisi +
                    ": 3",
            },
        },
        errorElement: "em",
        errorPlacement: function (i, e) {
            i.addClass("invalid-feedback"),
                "checkbox" === e.prop("type")
                    ? i.insertAfter(e.next("label"))
                    : i.insertAfter(e);
        },
        highlight: function (i, e, a) {
            $(i).addClass("is-invalid").removeClass("is-valid");
        },
        unhighlight: function (i, e, a) {
            $(i).addClass("is-valid").removeClass("is-invalid");
        },
        submitHandler: function (form) {
            unmaskNumber = $("input[name='number']").val().replace(/\D/g, "");
            $("input[name='number']").val(unmaskNumber);
            unmaskExpiry = $("input[name='expiry']")
                .val()
                .replace(/[\s/]/g, "");
            $("input[name='expiry']").val(unmaskExpiry);
            form.preventDefault();
        },
    });

    $("#sozlesmeText").on("click", function () {
        mpCalistir("#sozlesmePopup", true);
    });
});

$("#dogumTarihi").mask("00-00-0000");
$(".phonemask").mask("(000) 000 0000");
$(".iban-input").on("input", function () {
    var inputValue = $(this).val();
    inputValue = inputValue.replace(/[^A-Za-z0-9]/g, "");
    inputValue = inputValue.replace(/\s/g, "");
    inputValue = inputValue.toUpperCase();
    // 4 karakter aralıklarında boşluk ekle
    $(this).val(inputValue);
});

$(".iban-mask").mask("SS00 0000 0000 0000 0000 00", {
    placeholder: "____ ____ ____ ____ ____ __",
});
$(".gecerlilikTarih").mask("00 / 00");
$(".kartNo").mask("0000 0000 0000 0000", {
    placeholder: "•••• •••• •••• ••••",
});
$(".cvc").mask("0000");

$.extend(true, $.magnificPopup.defaults, {
    closeOnBgClick: false,
    callbacks: {
        open: function () {
            if (this.st.closeOnBgClick) {
                // Popup açıldığında dışarıya tıklamayı etkinleştir
                $(".mfp-bg").on("click", function () {
                    $.magnificPopup.close();
                });
            }
        },
    },
});

function mpCalistir(id, closeOnBgClick = false) {
    var popupContent = $(id);
    $.magnificPopup.open({
        items: {
            src: popupContent,
            type: "inline",
        },
        callbacks: {
            beforeOpen: function () {
                // closeOnBgClick parametresine göre davranışı ayarla
                this.st.closeOnBgClick = closeOnBgClick;
            },
        },
    });
}

function kayitFormunuYolla(form) {
    var formData = $(form).serialize();
    var url = $(form).attr("action");
    if (formData.trim() != "") {
        var veri = formData;
        $.ajax({
            type: "POST",
            method: "POST",
            data: veri,
            url: url,
            dataType: "json",
            beforeSend: function () {},
            success: function (cevap) {
                try {
                    if (cevap.durum == "success") {
                        if (cevap.data.SmsDogrulama === true) {
                            mpCalistir("#smsFormPopup");
                        } else {
                            window.location.href = cevap.data.YonlendirmeUrl;
                        }
                    } else {
                        $("#errContent").html(cevap.mesaj);
                        mpCalistir("#ajaxErrPopup");
                    }
                } catch (error) {}
            },
            error: function (hata) {
                $("#errContent").html(hata.responseText);
                mpCalistir("#ajaxErrPopup");
            },
        });
    }
}

function smsFormunuYolla(form) {
    var formData = $(form).serialize();
    var url = $(form).attr("action");
    if (formData.trim() != "") {
        var veri = formData;
        $.ajax({
            type: "POST",
            method: "POST",
            data: veri,
            url: url,
            dataType: "json",
            beforeSend: function () {},
            success: function (cevap) {
                try {
                    if (cevap.durum == "success") {
                        window.location.href = cevap.data.YonlendirmeUrl;
                    } else {
                    }
                } catch (error) {}
            },
            error: function (hata) {},
        });
    }
}

function kayitSorgulaFormunuYolla(form) {
    var formData = $(form).serialize();
    var url = $(form).attr("action");
    if (formData.trim() != "") {
        var veri = formData;
        $.ajax({
            type: "POST",
            method: "POST",
            data: veri,
            url: url,
            dataType: "json",
            beforeSend: function () {},
            success: function (cevap) {
                if (cevap.captcha !== undefined) {
                    $("#captchaImg").html(cevap.captcha);
                }
                try {
                    if (cevap.durum == "success") {
                        // console.log(cevap);
                        $("#sorguSonucWrap").fadeIn(200);
                        $("#sorguSonucBaslik")
                            .html(lang_kayit_bulundu)
                            .attr("style", "color:#38c172");
                        $("#sorguSonucIcon")
                            .removeClass()
                            .addClass("pbmit-base-icon-check")
                            .attr("style", "color:#38c172");
                        $("#sorguSonucMesaj").html(
                            `${cevap.data.Ad} ${cevap.data.Soyad} adına "${cevap.data.Yaris.Baslik}" (${cevap.data.Yaris.KayitUcreti}₺) ` +
                                " " +
                                lang_kayit_sorgula_basarili_adina_kaydiniz_var
                        );
                        $("#sorguSonucLink2")
                            .show()
                            .attr("href", cevap.data.Yaris.Url);
                        $("#sorguSonucLink3")
                            .show()
                            .attr("href", cevap.data.KayitGorselUrl);
                        var scrollToPosition =
                            $("#sorguSonucWrap").offset().top;
                        $("html, body").animate(
                            { scrollTop: scrollToPosition },
                            400
                        );
                    } else if (cevap.durum == "error") {
                        $("#sorguSonucWrap").fadeOut();
                        $("#errContent").html(cevap.mesaj);
                        mpCalistir("#ajaxErrPopup");
                    } else {
                        $("#sorguSonucWrap").fadeIn(200);
                        $("#sorguSonucBaslik")
                            .html(lang_kayit_bulunamadi)
                            .attr("style", "color:#ff6b66");
                        $("#sorguSonucIcon")
                            .removeClass()
                            .addClass("pbmit-base-icon-cancel")
                            .attr("style", "color:#ff6b66");
                        $("#sorguSonucMesaj").html(
                            lang_kayit_sorgula_basarisiz_kayit_bulunamadi
                        );
                        $("#sorguSonucLink2").attr("href", "").hide();
                        $("#sorguSonucLink3").attr("href", "").hide();
                        var scrollToPosition =
                            $("#sorguSonucWrap").offset().top;
                        $("html, body").animate(
                            { scrollTop: scrollToPosition },
                            400
                        );
                    }
                } catch (error) {
                    $("#sorguSonucWrap").fadeOut();
                    $("#errContent").html(error);
                    mpCalistir("#ajaxErrPopup");
                }
            },
            error: function (hata) {
                $("#sorguSonucWrap").fadeOut();
                $("#errContent").html(hata.responseText);
                mpCalistir("#ajaxErrPopup");
            },
        });
    }
}
